import { VUEX_CONTENT_MUTATION_NAMES } from "@tt-app/constants/content";

const {
  BOOKMARKED_COURSES,
  COURSE_DETAILS,
  ORG_COURSES,
  RECOMMENDED_COURSES,
  LOADING_BOOKMARKED_COURSES,
  LOADING_RECOMMENDED_COURSES
} = VUEX_CONTENT_MUTATION_NAMES;

const contentMutations = {
  [BOOKMARKED_COURSES](state: any, { courses }: any) {
    state.bookmark.courses = courses;
  },
  [LOADING_BOOKMARKED_COURSES](state: any, load: boolean) {
    state.bookmark.loading = load;
  },
  [COURSE_DETAILS](state: any, { courseDetails }: any) {
    state.course.details = courseDetails;
  },
  [ORG_COURSES](state: any, courses: any) {
    state.organization.courses = courses;

    const categories = courses.reduce((accumulator: any, course: any) => {
      course.categories.forEach(({ name, uuid }: any) => {
        const newCount = (accumulator[uuid] && accumulator[uuid].count) || 0;

        accumulator[uuid] = {
          count: newCount + 1,
          name
        };
      });

      return accumulator;
    }, {});

    const cefrjLevelCounts = courses.reduce((accumulator: any, course: any) => {
      const level = course.cefrj;
      const count = accumulator[level] || 0;

      accumulator[level] = count + 1;

      return accumulator;
    }, {});

    state.organization.cefrjLevelCounts = cefrjLevelCounts;
    state.organization.categories = categories;
  },
  [RECOMMENDED_COURSES](state: any, courses: Array<any>) {
    state.recommended.courses = courses;
  },
  [LOADING_RECOMMENDED_COURSES](state: any, load: boolean) {
    state.recommended.loading = load;
  }
};

export { contentMutations };
